import { AdminMenuItems } from '../model/AdminMenuItems'
import { KedoContext } from '../model/types'

export const useAdminPermissions = (kedo: KedoContext) => {
    const hasAdminAccess = (): boolean => {
        if (kedo.isAdminOrEnvironmentAdmin()) {
            return true
        }

        const environment = kedo.env().getEnvironment()
        const credentials: string[] = environment?.credentials || []

        return AdminMenuItems.some((adminPermission) =>
            credentials.some((cred) =>
                cred.startsWith(adminPermission.permission)
            )
        )
    }

    return {
        hasAdminAccess,
    }
}